module.exports = __webpack_public_path__ + "img/tab_02_active.81473396.svg";